import React, { FocusEventHandler, useId } from 'react';

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export type AccommV2BookableFilter = 'true' | 'false' | '';

const OPTIONS: Array<{ value: AccommV2BookableFilter; label: string }> = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Booking enabled' },
  { value: 'false', label: 'Booking disabled' },
];

export function isAccommV2BookableFilter(value: string): value is AccommV2BookableFilter {
  return OPTIONS.some((option) => option.value === value);
}

interface Props {
  value: AccommV2BookableFilter;
  onChange: (newValue: AccommV2BookableFilter) => void;
  onFocus?: FocusEventHandler;
}

export default function AccommodationV2BookableFilterInput({ value, onChange, onFocus }: Props) {
  const labelId = useId();

  return (
    <FormControl fullWidth>
      <InputLabel id={labelId} shrink>
        Booking enabled
      </InputLabel>
      <Select<AccommV2BookableFilter>
        labelId={labelId}
        value={value}
        label="Booking enabled"
        displayEmpty
        notched
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
      >
        {OPTIONS.map((option) => (
          <MenuItem key={option.value || 'all'} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
